import React, { useState } from 'react';
import { BsFileText } from 'react-icons/bs'; // Changed to use BsFileText from react-icons/bs
import TableComponent from './../../components/widgets/table/index';
import { api_srv } from 'services';


function RenewalsReports() {

              async function fetch_renewals() {
                let resp = await (await api_srv).fetchRenewals();
                console.log("resp===", resp)
                return resp.data;
              }

  const allRenewalData = [
    { id: 1, policy: 'POL001', client: 'Mike Davis', renewalDate: '2025-01-01', premium: 500.00, status: 'Renewed' },
    { id: 2, policy: 'POL002', client: 'Sarah Wilson', renewalDate: '2025-01-20', premium: 350.00, status: 'Pending' },
    { id: 3, policy: 'POL003', client: 'David Lee', renewalDate: '2025-02-10', premium: 700.00, status: 'Renewed' },
    { id: 4, policy: 'POL004', client: 'Emily Chen', renewalDate: '2025-02-28', premium: 400.00, status: 'Expired' }
  ];

  const months = [
    { name: 'January', value: 0 }, { name: 'February', value: 1 }, { name: 'March', value: 2 },
    { name: 'April', value: 3 }, { name: 'May', value: 4 }, { name: 'June', value: 5 },
    { name: 'July', value: 6 }, { name: 'August', value: 7 }, { name: 'September', value: 8 },
    { name: 'October', value: 9 }, { name: 'November', value: 10 }, { name: 'December', value: 11 }
  ];

  const currentMonth = new Date().getMonth();
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [showCards, setShowCards] = useState(true);

  const filteredRenewalData = allRenewalData.filter(item => {
    const itemMonth = new Date(item.renewalDate).getMonth();
    return itemMonth === selectedMonth;
  });

  const getCountForMonth = (monthValue) => {
    return allRenewalData.filter(item => new Date(item.renewalDate).getMonth() === monthValue).length;
  };

  const renewalTableFields = [
    { name: 'Policy' },
    { name: 'Client' },
    { name: 'Renewal Date' },
    { name: 'Premium' },
    { name: 'Status' },
  ];

  const renewalRowData = [
    { type: 'text', field: 'policy' },
    { type: 'text', field: 'client' },
    { type: 'date', field: 'renewalDate' },
    { type: 'currency', field: 'premium' },
    { type: 'status', field: 'status' },
  ];

  const handleMonthClick = (monthValue) => {
    setSelectedMonth(monthValue);
    setShowCards(false);
  };

  return (
    <div className="min-vh-100 bg-light pb-5">
      <div className="bg-white shadow-sm border-bottom">
        <div className="container py-4">
          <h1 className="h3 font-weight-bold text-dark">Renewals</h1>
          <p className="text-muted mb-0">Overview of all renewals by month.</p>
        </div>
      </div>

      <div className="container py-5">
        {showCards ? (
          <div className="d-flex flex-wrap justify-content-start align-items-stretch" style={{ gap: '2rem' }}>
            {months.map((month, index) => (
              <div key={index} style={{ flex: '0 0 calc(25% - 1.5rem)', maxWidth: 'calc(25% - 1.5rem)', marginTop: '2rem' }}>
                <div
                  className="card h-100 border-0 shadow-sm text-center py-4 cursor-pointer rounded"
                  onClick={() => handleMonthClick(month.value)}
                >
                  <div className="card-body d-flex flex-column align-items-center justify-content-center">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center mb-2"
                      style={{ backgroundColor: '#f59e0b', width: '64px', height: '64px' }} // Renewals color from Reports page
                    >
                      <BsFileText className="text-white" size={32} />
                    </div>
                    <h2 className="font-weight-bold mb-0 text-dark">{getCountForMonth(month.value)}</h2>
                    <p className="card-text mt-2 mb-0 text-dark">{month.name}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <TableComponent
            title={`Renewals for ${months[selectedMonth].name}`}
            table_fields={renewalTableFields}
            row_data={renewalRowData}
            table_data={filteredRenewalData}
          />
        )}
      </div>
    </div>
  );
}

export default RenewalsReports;
